import type { ReactNode } from 'react';
import type { DocumentStatus } from '@erp-attach/shared';

export type ChipVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export function Chip({
  variant = 'info',
  children,
  title,
  className = '',
}: {
  variant?: ChipVariant;
  children: ReactNode;
  title?: string;
  className?: string;
}) {
  return (
    <span className={`gsl-chip gsl-chip-${variant} ${className}`} title={title}>
      {children}
    </span>
  );
}

const STATUS_META: Record<DocumentStatus, { label: string; variant: ChipVariant; title: string }> = {
  uploading: { label: 'Uploading', variant: 'info', title: 'Upload in progress' },
  scanning: { label: 'Scanning', variant: 'warning', title: 'Waiting for the malware scan verdict' },
  available: { label: 'Available', variant: 'success', title: 'Clean and ready to view' },
  rejected: { label: 'Rejected', variant: 'danger', title: 'Rejected by the scan or the type policy' },
  hidden: { label: 'Hidden', variant: 'neutral', title: 'Hidden from the folder list' },
  purged: { label: 'Removed', variant: 'neutral', title: 'Removed by Records.Admin' },
};

export function StatusChip({ status, hidden }: { status: DocumentStatus; hidden?: boolean }) {
  const meta = hidden && status === 'available' ? STATUS_META.hidden : STATUS_META[status];
  return (
    <Chip variant={meta.variant} title={meta.title}>
      {meta.label}
    </Chip>
  );
}
